module.exports = __webpack_public_path__ + "img/algeria.f904aff5.svg";